import { AsyncPipe } from "@angular/common";
import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { CountrySelectionFormFieldComponent } from "@components/country-selection-form-field/country-selection-form-field.component";
import { Country, MapCountryNamePipe } from "@domain/user/locale/country";
import { UserLocaleService } from "@domain/user/locale/user-locale.service";
import { AutocompleteModule } from "@odx/angular/components/autocomplete";
import { FormDirective } from "@odx/angular/components/form-field";
import { Observable } from "rxjs";

@Component({
  selector: "app-country-selection",
  imports: [AsyncPipe, FormDirective, UiKitModule, AutocompleteModule, ReactiveFormsModule, CountrySelectionFormFieldComponent],
  providers: [MapCountryNamePipe],
  templateUrl: "./country-selection-menu.component.html",
  styleUrl: "./country-selection-menu.component.scss",
  standalone: true,
})
export class CountrySelectionMenuComponent implements OnInit {
  @Input({ required: true }) selectedCountry!: string;
  @Output() selectionChange: EventEmitter<string> = new EventEmitter<string>();

  protected countrySelectionForm!: FormGroup;
  protected supportedCountries$: Observable<Country[]>;

  private formBuilder = inject(FormBuilder);
  private mapCountryNamePipe = inject(MapCountryNamePipe);
  private userLocaleService = inject(UserLocaleService);

  constructor() {
    this.supportedCountries$ = this.userLocaleService.supportedCountries$;
    this.countrySelectionForm = this.formBuilder.group({
      country: null,
    });
  }

  ngOnInit() {
    this.countrySelectionForm.patchValue({
      country: this.mapCountryNamePipe.transform(this.selectedCountry),
    });
  }

  selectCountry($event: string) {
    this.selectionChange.emit($event);
  }
}
